var angular = require('angular');
var _module = angular.module('benoit');

require('./_styles.scss');
require('../../services/lr-touch');

_module.component('pageit', {
    template: require('./index.html'),
    bindings: {
        totalPages: '@',
        startOnPage: '@',
        onPageChange: '&'
    },
    controllerAs: 'pageit',
    controller: [
        '$log',
        '$scope',

        function pageitCtrl($log, $scope) {
            $log.debug('Page It');

            var _this = this;

            var calculateMaxAcross = function calculateMaxAcross() {
                var defaultMaxAcross = 5;
                return (!isNaN(_this.totalPages) && parseInt(_this.totalPages, 10) <= defaultMaxAcross)
                    ? _this.totalPages
                    : defaultMaxAcross;
            };

            this.maxAcross = calculateMaxAcross();
            this.currentPage = parseInt(this.startOnPage || 1);

            // Ctrl Functions
            this.createArray = function createArray(num) {
                if(isNaN(num) || (!isNaN(num) && parseInt(num, 10) < 0)) {
                    // reset num to 0 if it's not a valid number or it's negative
                    num = 0;
                }
                return new Array(parseInt(num));
            };

            this.getListOffset = function getListOffset() {
                if(_this.currentPage < 4) {
                    return 2;
                } else if(_this.currentPage > _this.totalPages - 3) {
                    return _this.totalPages - 3;
                } else {
                    return _this.currentPage - 1;
                }
            };

            this.gotoPage = function gotoPage(page) {
                $log.debug('Page', page);

                _this.currentPage = page;
                _this.onPageChange({ $page: _this.currentPage });
            };


            // Watchers

            $scope.$watch(function () {
                return _this.startOnPage;
            }, function (newVal, oldVal) {
                if(newVal !== oldVal && !isNaN(newVal)) {
                    _this.currentPage = parseInt(newVal, 10);
                }
            });

            $scope.$watch(function () {
                return _this.totalPages;
            }, function (newVal, oldVal) {
                if(newVal !== oldVal && !isNaN(newVal)) {
                    _this.maxAcross = calculateMaxAcross();
                }
            });
        }
    ]
});
